<template>
<v-container fluid>
  <div class="page-shell">
    <filter-form-user :roleNameList="getRoleNameList"></filter-form-user>
    <dialog-form-user :formTitle="formTitle"></dialog-form-user>
    <v-card class="page-card">
      <v-toolbar color="primary" class="page-toolbar">
        <v-toolbar-title>Usuarios</v-toolbar-title>
        <v-btn v-if="canCreate" color="white" variant="flat" class="toolbar-add-button" @click="addUser()">Agregar Usuario</v-btn>
      </v-toolbar>
      <v-data-table :headers="headers" :items="users" :items-per-page-options="CONST.ROWS_PER_PAGE_ITEMS">
        <template #[`item.active`]="{ item }">
          <v-chip :color="getRawItem(item).active ? 'success' : 'default'" size="small">{{ getRawItem(item).active ? 'Activo' : 'Inactivo' }}</v-chip>
        </template>
        <template #[`item.actions`]="{ item }">
          <div class="action-cell">
            <v-btn v-if="canEdit" icon size="small" variant="text" class="table-action-button" aria-label="Editar" @click="editItem(getRawItem(item))">
              <v-icon>edit</v-icon>
            </v-btn>
            <v-btn v-if="getRawItem(item).active ? canDisable : canActivate" icon size="small" variant="text" class="table-action-button" :class="{ 'table-action-danger': getRawItem(item).active }" :aria-label="getRawItem(item).active ? 'Desactivar' : 'Reactivar'" @click="changeActive(getRawItem(item))">
              <v-icon>{{ getRawItem(item).active ? 'person_off' : 'person_add' }}</v-icon>
            </v-btn>
          </div>
        </template>
        <template #no-data>
          <span>{{ CONST.NO_RESULTS_CHECK_FILTERS }}</span>
          <v-btn color="primary" class="ml-3" @click="initialize">{{ CONST.REFRESH }}</v-btn>
        </template>
      </v-data-table>
    </v-card>
  </div>
</v-container>
</template>
<script>
import CONST from '../../services/common/Constants.js'
import { mapGetters } from 'vuex'
import FilterForm from './FilterUserForm'
import AddEditUserForm from './AddEditUserForm'
import userRestService from '../../services/user/UserRestService'

export default {
  components: {
    'filter-form-user': FilterForm,
    'dialog-form-user': AddEditUserForm
  },
  data: () => ({
    CONST: {},
    dialog: false,
    formTitle: 'Agregar usuario',
    headers: [
      {title: 'Usuario', align: 'center', key: 'username'},
      {title: 'Roles', align: 'center', key: 'roleLabels'},
      {title: 'Compania', align: 'center', key: 'company.name'},
      {title: 'Estado', align: 'center', key: 'active'},
      {title: 'Acciones', align: 'center', key: 'actions', sortable: false}
    ],
    users: []
  }),

  computed: {
    ...mapGetters('userModule', ['getUsers', 'getRoles', 'getRoleNameList', 'getFilteredUsers', 'getUserSavedSuccessfully']),
    ...mapGetters('authModule', ['hasPermission']),
    canCreate () { return this.hasPermission('security.users.create') && this.hasPermission('security.users.assign_role') },
    canEdit () { return ['security.users.update', 'security.users.assign_role', 'security.users.password_reset'].some(this.hasPermission) },
    canDisable () { return this.hasPermission('security.users.disable') },
    canActivate () { return this.hasPermission('security.users.activate') }
  },

  created () {
    this.initialize()
    this.CONST = CONST
  },

  watch: {
    getFilteredUsers: function () {
      this.users = this.$store.getters['userModule/getFilteredUsers']
    },
    getUserSavedSuccessfully: function (newValue, oldValue) {
      if (newValue === true && oldValue === false) {
        this.initialize()
      }
    }
  },

  methods: {
    initialize () {
      return this.$store.dispatch('userModule/getRoles')
        .then(() => {
          this.$store.dispatch('userModule/getUsers').then(() => {
            this.users = this.$store.getters['userModule/getUsers'].map(user => ({
              ...user,
              roleLabels: (user.roles || []).map(role => role.displayName).join(', ')
            }))
          })
        })
    },

    addUser () {
      this.formTitle = 'Agregar Usuario'
      this.$store.dispatch('userModule/setDialogActived', true)
    },

    getRawItem (item) {
      return item.raw || item
    },

    editItem (item) {
      this.formTitle = 'Editar Usuario: ' + item.username
      this.$store.dispatch('userModule/setEditedItem', Object.assign({}, item))
      this.$store.dispatch('userModule/setDialogActived', true)
    },

    async changeActive (item) {
      const action = item.active ? 'desactivar' : 'reactivar'
      if (!confirm(`¿${action[0].toUpperCase() + action.slice(1)} a ${item.username}?`)) return
      const reason = prompt('Motivo del cambio (mínimo 3 caracteres):')
      if (!reason || reason.trim().length < 3) return
      try {
        await userRestService.changeActive(item.id, { version: item.version, active: !item.active, reason })
        await this.initialize()
      } catch (error) {
        this.$store.commit('setSnackBarStatus', { actived: true, message: error.response?.data?.message || 'No se pudo cambiar el estado.', color: 'error' })
      }
    }
  }
}
</script>
